import OpenReplay from "@openreplay/tracker";
import trackerGraphQL from "@openreplay/tracker-graphql";
import trackerAssist from "@openreplay/tracker-assist";
import * as Sentry from "@sentry/react";

const openReplayTracker = new OpenReplay({
	projectKey: process.env.OPEN_REPLAY_PROJECT_KEY,
	ingestPoint: "https://openreplay.getgivemefive.com/ingest",
	obscureInputDates: false,
	obscureTextNumbers: false,
	defaultInputMode: 0,
});

openReplayTracker.use(trackerAssist());

export default openReplayTracker;
